import { ref, computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useCurrentUserStore } from "@stores/currentUser";
import { useSurveyStore } from "@stores/survey/survey";

export const useSurveySetupStore = defineStore("surveySetup", () => {
  // imported stores
  const currentUserStore = useCurrentUserStore();
  const { isAdmin } = storeToRefs(currentUserStore);
  const surveyStore = useSurveyStore();
  const { isInitiallyDraft } = storeToRefs(surveyStore);

  const activeItems = ref(["general"]);
  const sections = ref([
    { name: "general", label: "General", admin: false, draft: false },
    { name: "contract_credits", label: "Contract & Credits", admin: false, draft: false },
    { name: "default_messages", label: "Default messages", admin: false, draft: false },
    { name: "cards_generation", label: "Survey reset", admin: false, draft: true },
  ]);

  const currentSections = computed(() =>
    sections.value.filter((s) => (s.admin === false || isAdmin.value) && (s.draft === false || isInitiallyDraft.value)),
  );

  return {
    isAdmin,
    currentSections,
    activeItems,
  };
});
